import React, { useState, useEffect } from 'react';
import { ArticleCreate } from '../types/article';
import { createArticle } from '../api/articles';

interface ManualInputFormProps {
  categories: string[];
  selectedDate: string;
  onArticleCreated: () => void;
  onClose: () => void;
}

const ManualInputForm: React.FC<ManualInputFormProps> = ({
  categories,
  selectedDate,
  onArticleCreated,
  onClose,
}) => {
  const [date, setDate] = useState(selectedDate || new Date().toISOString().split('T')[0]);
  const [category, setCategory] = useState(categories[0] || '');
  const [press, setPress] = useState('');
  const [title, setTitle] = useState('');
  const [url, setUrl] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setDate(selectedDate || new Date().toISOString().split('T')[0]);
  }, [selectedDate]);

  useEffect(() => {
    if (categories.length > 0 && !category) {
      setCategory(categories[0]);
    }
  }, [categories, category]);

  const resetForm = () => {
    setDate(selectedDate || new Date().toISOString().split('T')[0]);
    setCategory(categories[0] || '');
    setPress('');
    setTitle('');
    setUrl('');
  };

  const handleSubmit = async () => {
    if (!date || !category || !press.trim() || !title.trim() || !url.trim()) {
      alert('모든 필드를 입력해주세요.');
      return;
    }

    setIsSubmitting(true);
    try {
      const data: ArticleCreate = {
        date,
        category,
        press: press.trim(),
        title: title.trim(),
        url: url.trim(),
      };
      await createArticle(data);
      alert('기사가 추가되었습니다.');
      resetForm();

      if (selectedDate === date) {
        onArticleCreated();
      } else {
        if (window.confirm('입력한 날짜로 이동하시겠습니까?')) {
          // Navigate to the new date - parent will handle this
          onArticleCreated();
        }
      }
    } catch (error) {
      console.error('Error creating article:', error);
      alert('기사 추가 중 오류가 발생했습니다: ' + (error as Error).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="manual-input-form">
      <div className="form-group">
        <label>날짜</label>
        <input
          type="date"
          className="form-input"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>카테고리</label>
        <select
          className="form-input"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          style={{ minWidth: 100 }}
        >
          {categories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <label>언론사</label>
        <input
          type="text"
          className="form-input"
          placeholder="언론사명"
          value={press}
          onChange={(e) => setPress(e.target.value)}
          style={{ width: 120 }}
        />
      </div>
      <div className="form-group" style={{ flexGrow: 1, minWidth: 200 }}>
        <label>제목</label>
        <input
          type="text"
          className="form-input"
          placeholder="기사 제목"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          style={{ width: '100%' }}
        />
      </div>
      <div className="form-group" style={{ flexGrow: 1, minWidth: 200 }}>
        <label>URL</label>
        <input
          type="text"
          className="form-input"
          placeholder="https://..."
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          style={{ width: '100%' }}
        />
      </div>
      <div className="form-group" style={{ flexDirection: 'row' }}>
        <button className="btn-add" onClick={handleSubmit} disabled={isSubmitting}>
          {isSubmitting ? '추가 중...' : '추가'}
        </button>
        <button className="btn-cancel-add" onClick={onClose}>
          취소
        </button>
      </div>
    </div>
  );
};

export default ManualInputForm;
